import { render, staticRenderFns } from "./companyMember.vue?vue&type=template&id=377ad564&scoped=true&"
import script from "./companyMember.vue?vue&type=script&lang=js&"
export * from "./companyMember.vue?vue&type=script&lang=js&"
import style0 from "./companyMember.vue?vue&type=style&index=0&id=377ad564&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377ad564",
  null
  
)

export default component.exports